package com.tixforgigs.common.ui.components.templateConfigurator


import com.tixforgigs.common.core.annotations.MissingTaramiMessageKey
import com.tixforgigs.common.core.util.IdHelper.generateRandomId
import com.tixforgigs.common.ui.components.mandarin.mandarinHeadline
import com.tixforgigs.apax.models.CustomVariable
import io.kvision.core.Container
import io.kvision.event.changeFlow
import io.kvision.html.fieldset
import io.kvision.html.label
import io.kvision.html.span
import io.kvision.material.ExperimentalMaterialApi
import io.kvision.material.checkbox.checkbox
import io.kvision.material.widget.TouchTarget
import io.kvision.panel.simplePanel
import io.kvision.state.bind
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.flow.*

@OptIn(ExperimentalMaterialApi::class)
fun Container.customVarOptions(
  state: MutableStateFlow<List<CustomVariable>>,
) {
  @MissingTaramiMessageKey
  mandarinHeadline(subheadline = "Custom Styles")

  fieldset(className = "xm-inputs").bind(state) { list ->
    list.forEach { item ->
      simplePanel(className = "xm-customvar-chooser") {

        val checkboxId = generateRandomId(numbersAllowed = false)
        val checkboxState = MutableStateFlow(false)
        if (item.value == "true") {
          checkboxState.value = true
        }

        checkbox {
          id = checkboxId
          touchTarget = TouchTarget.Wrapper
        }.bind(checkboxState) {
          checked = it
        }.changeFlow.onEach {
          checkboxState.updateAndGet { it.not() }.let { currentState ->
            state.update { stateList ->
              stateList.map { stateItem ->
                if (stateItem.variable == item.variable) {
                  stateItem.copy(value = if (currentState) "true" else "false")
                } else stateItem
              }
            }
          }
        }.launchIn(MainScope())

        label(forId = checkboxId) { +item.variable }
      }
    }
    if (list.isEmpty()) {
      @MissingTaramiMessageKey
      span { +"aktuell kannst du keine Konfigurationen bearbeiten" }
    }
  }


}
